import {
  IonButton,
  IonButtons,
  IonCard,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonSpinner,
  IonText,
  IonTitle,
  IonToolbar,
  IonContent,
} from "@ionic/react";
import { addCircleOutline, documentTextOutline, personOutline } from "ionicons/icons";

import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../../store/rootReducer";
import { setPreselectAll, setPreselectDocumentType } from "../../../store/MassNotification";
import { selectDocumentTypesAvailable } from "../../../store/MassNotification/selectors/selectDocumentTypesAvailable";
import { findTotalPeople } from "../../../store/MassNotification/actions/findTotalPeople";

const countStyle = {
  verticalAlign: "middle",
};

export const DocumentTypesSelector = () => {
  const dispatch = useDispatch();
  const documentTypes = useSelector(selectDocumentTypesAvailable);
  const state = useSelector((state: RootState) => state.massNotification);

  const handlePreselectAll = async () => {
    dispatch(setPreselectAll(documentTypes));
    dispatch(findTotalPeople());
  };

  return (
    <IonCard style={{ height: "75vh" }} class="ion-no-margin">
      <IonToolbar>
        <IonTitle size="small" style={{ fontWeight: 500 }}>
          Disponibles {documentTypes && <span>({documentTypes.length})</span>}{" "}
        </IonTitle>
        <IonButtons slot="end">
          {!!documentTypes.length && (
            <IonButton fill="solid" size="small" color="primary" onClick={handlePreselectAll}>
              <small>Agregar todos</small>
              <IonIcon icon={addCircleOutline} slot="end" />
            </IonButton>
          )}
        </IonButtons>
      </IonToolbar>
      <IonContent style={{ overflow: "scroll", height: "68vh" }}>
        <IonList>
          {state.findDocumentTypesStatus === "succeeded" &&
            documentTypes.map((item) => (
              <IonItem key={item.id}>
                <IonLabel className="ion-hide-md-up" text-wrap>
                  <h5 style={{ fontWeight: 700 }}>
                    <IonText color="primary">{item.name}</IonText>
                  </h5>
                  <IonText color="primary">
                    <IonIcon icon={documentTextOutline} style={countStyle}></IonIcon>{" "}
                    <span style={countStyle}>{item.documentCount}</span>{" "}
                    <IonIcon icon={personOutline} style={countStyle}></IonIcon>{" "}
                    <span style={countStyle}>{item.peopleCount}</span>
                  </IonText>
                </IonLabel>
                <IonLabel className="ion-hide-md-down" text-wrap>
                  <h3 style={{ fontWeight: 700 }}>
                    <IonText color="primary">{item.name}</IonText>
                  </h3>
                  <IonText color="primary">
                    <IonIcon icon={documentTextOutline} style={countStyle}></IonIcon>{" "}
                    <span style={countStyle}>{item.documentCount}</span>{" "}
                    <IonIcon icon={personOutline} style={countStyle}></IonIcon>{" "}
                    <span style={countStyle}>{item.peopleCount}</span>
                  </IonText>
                </IonLabel>
                <IonButton
                  fill="clear"
                  onClick={() => {
                    dispatch(setPreselectDocumentType(item));
                    dispatch(findTotalPeople());
                  }}
                  size="default"
                >
                  <IonIcon icon={addCircleOutline} />
                </IonButton>
              </IonItem>
            ))}
          {state.findDocumentTypesStatus === "pending" && (
            <p className="ion-text-center">
              <IonSpinner />
            </p>
          )}
        </IonList>
      </IonContent>
    </IonCard>
  );
};
